import { Configuration, ConfigurationObject } from "@shared/interfaces";
const { REACT_APP_ENV = "dev", REACT_APP_API_URL, REACT_APP_API_BASE_URL } = process.env;

// `dev` is the LOCAL development tier only -- it is never deployed. The CI workflow resolves
// REACT_APP_ENV to exactly "production" or "qa" and nothing else (.github/workflows/main.yml, the
// `configure` job), so pointing this at localhost cannot affect any deployed environment.
//
// REACT_APP_API_BASE_URL is consulted HERE, inside `dev`, and deliberately nowhere else. qa/stage/
// production each spread `dev` and then overwrite `baseApiUrl`, so this name can only ever redirect local
// development -- it cannot reach a qa or production bundle even when it is set. CI never sets it at all
// (the Build step in .github/workflows/main.yml passes only REACT_APP_ENV and REACT_APP_API_URL).
// `||` rather than `??` so an `X=` line falls back too: CRA injects an unset var as undefined but an
// empty assignment as "".
const dev: Configuration = {
  env: REACT_APP_ENV,
  baseApiUrl: REACT_APP_API_BASE_URL || "http://localhost:4000/api/v1/",
  googleClientId: "590361666667-q2sliro1ottrbrb0k14uq2sqmjjp4ds0.apps.googleusercontent.com",
};

const qa: Configuration = {
  ...dev,
  baseApiUrl: "https://api.qa.core.ninetwothree.co/api/v1/",
};

const stage: Configuration = {
  ...dev,
  baseApiUrl: "https://api.uat.core.ninetwothree.co/api/v1/",
};

const production: Configuration = {
  ...dev,
  baseApiUrl: "https://api.core.ninetwothree.co/api/v1/",
};

const config: ConfigurationObject = {
  dev,
  qa,
  production,
  stage,
};

// REACT_APP_API_URL is the tier-wide override, and the only one of the two names CI ever sets:
// .github/workflows/main.yml passes it to the Build step from the `configure` job's `api_url` output --
// the api1 host for the `prod-app1` target, and the EMPTY STRING for plain `prod` and for `qa`.
// That empty string is exactly why this is a truthiness check and not `??`: on every ordinary prod/qa
// build the variable IS set, just to "", and it must fall through to the hardcoded per-environment
// baseApiUrl above rather than blanking it.
const configElement: Configuration = {
  ...config[REACT_APP_ENV],
  ...(REACT_APP_API_URL ? { baseApiUrl: REACT_APP_API_URL } : {}),
};
export default configElement;
